import { Grid, Typography, RadioGroup, FormControlLabel, Radio, Paper } from '@mui/material';
import KenSelect from '../../../../../../GlobalComponents/KenSelect';
import { DROP_DOWN, QuizConfig } from '../Helper/AssessmentHelper';

interface ILayout {
    assessmentData: QuizConfig;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
const LayoutSettings: React.FC<ILayout> = ({ assessmentData, handleChange }: ILayout) => {
    return (
        <Grid container spacing={3}>
            {/* No. of questions per page */}
            <Grid item xs={12} md={4}>
                <Typography fontWeight={500} textAlign="left">
                    No. of questions per page
                </Typography>
                <KenSelect
                    fullWidth
                    name="questionsperpage"
                    value={assessmentData.questionsperpage}
                    onChange={handleChange}
                    options={DROP_DOWN.QuestionPerPage}
                    sx={{ height: '3rem', marginTop: 1 }}
                />
            </Grid>

            {/* Navigation method */}
            <Grid item xs={12} md={12}>
                <Typography fontWeight={500} textAlign="left">
                    Navigation method
                </Typography>
                <RadioGroup row defaultValue="free"
                    name="navmethod"
                    value={assessmentData.navmethod}
                    onChange={handleChange}
                    sx={{ marginTop: 1 }}
                >
                    <FormControlLabel
                        value="free"
                        control={<Radio sx={{ color: '#3B82F6' }} />}
                        label={<Typography fontWeight={500} >Free navigation</Typography>}
                    />
                    <FormControlLabel
                        value="sequential"
                        control={<Radio sx={{ color: '#9CA3AF' }} />}
                        label={<Typography fontWeight={500}>Sequential</Typography>}
                    />
                </RadioGroup>
            </Grid>
        </Grid>
    );
}

export default LayoutSettings;